import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router'
import { useEffect } from 'react'
import { APP_ROUTES } from '@/common/constants'
import { APP } from '@/common/strings'
import { analytics } from '@/common/analytics/analytics'
import { ONBOARDING_COPY } from '@/locales/en'
import { NameForm } from './features/name/components/NameForm'
import { useNameLogic } from './features/name/useNameLogic'
import useUserStore from '@/user/userStore'
import { useOnboardingProgress } from './useOnboardingProgress'

export function Name() {
    const navigate = useNavigate()
    const { progress } = useOnboardingProgress()
    const logic = useNameLogic()
    const { user } = useUserStore()

    useEffect(() => {
        if (!logic.isSuccess) return
        analytics.trackWithDefaults('onboarding_name_submitted')
        analytics.identify(user?.userId, {
            firstName: logic.data?.firstName,
            lastName: logic.data?.lastName,
            salutation: logic.data?.salutation,
            middleName: logic.data?.middleName,
        })
        navigate(APP_ROUTES.ADDRESS)
    }, [logic.isSuccess, logic.data, user, navigate])

    return (
        <>
            <Helmet>
                <title>
                    {ONBOARDING_COPY.name.pageTitle} | {APP.title}
                </title>
            </Helmet>
            <NameForm
                progress={progress}
                defaultValues={logic.data}
                loading={logic.loading}
                saving={logic.saving}
                onSubmit={logic.onSubmit}
            />
        </>
    )
}
